export default __webpack_public_path__ + "static/media/squadgoalspic3.fb065542.png";